import React from 'react'
import styled from "styled-components";
import * as media from "../../../media";
import DesktopBanner from './Desktop'
import MobileBanner from './Mobile'

const BiggerThan1000Check = styled.div`
  ${media.smallerThan(700)`display:none;`}
`
const LessThan1000Check = styled.div`
  ${media.biggerThan(701)`display:none;`}
`

export default function Banner() {
  return (
    <div>
      <BiggerThan1000Check>
        <DesktopBanner/>
      </BiggerThan1000Check>
      <LessThan1000Check>
        <MobileBanner/>
      </LessThan1000Check>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/finwhale/common/retail-stores/index.js